module.exports = __webpack_public_path__ + "img/ENABLE.9b4217fd.svg";